<div class="widget-area">
  <div class="widget-archives footer-widget mb-50">
    <h3 class="widget-title">About</h3>
    <ul>
      <li class="menu-item-has-children" routerLinkActive="active">
        <ul class="sub-menu">
          <li><a routerLink="/about/college" routerLinkActive="active">College</a></li>
          <li><a routerLink="/about/management" routerLinkActive="active">Management</a></li>
          <li><a routerLink="/about/sri-balaji-educational-society" routerLinkActive="active">Sri Balaji Educational Society</a></li>
          <li><a routerLink="/about/balaji-sevasamithi" routerLinkActive="active">Balaji Sevasamithi</a></li>
          <li><a routerLink="/about/balaji-insurance" routerLinkActive="active">Balaji Insurance</a></li>
          <li><a routerLink="/about/principal" routerLinkActive="active">Principal</a></li>
        </ul>
      </li>
    </ul>
  </div>
</div>
